import React from "react";
import {MsalAuthenticationTemplate} from "../../auth/msalExports";

const isAuthBypass = process.env.REACT_APP_AUTH_BYPASS === 'true';

let loginRequest, InteractionType;
if (!isAuthBypass) {
    loginRequest = require("../../msalAuthConfig").loginRequest;
    InteractionType = require("@azure/msal-browser").InteractionType;
}

const withAuth = (Component) => {
    if (isAuthBypass) {
        // In bypass mode, just render the component directly
        return function AuthBypassComponent(props) {
            return <Component {...props} />;
        };
    }

    return class AuthenticatedComponent extends React.Component {
        render() {
            const authRequest = {
                ...loginRequest
            };

            return (
                <MsalAuthenticationTemplate
                    interactionType={InteractionType.Redirect}
                    authenticationRequest={authRequest}
                >
                    <Component {...this.props} />
                </MsalAuthenticationTemplate>
            );
        }
    }
}

export default withAuth;
